// import { set } from 'lodash'
import { errorHandler } from '../exports/error_management'
const AWS = require('aws-sdk')

const commands = {
    authUri: "authUri",
    callback: "callback",
    getRealm: "getRealm",
    getHost: "getHost",
    refreshAccessToken: "refreshAccessToken",
    getInvoiceByNumber: "getInvoiceByNumber",
    getDueInvoices: "getDueInvoices",
    getInvoicesByUpdateRange: "getInvoicesByUpdateRange",
    createInvoice: "createInvoice",
    getCompanyInfo: "getCompanyInfo",
    downloadExcel: "downloadExcel",
    disconnect: "disconnect",
    getAccounts: "getAccounts"
}

const state = {
    commands,
    loadingId: null,
    authUri_data: null,
    callback_data: null,
    getRealm_data: null,
    getHost_data: null,
    refreshAccessToken_data: null,
    getInvoiceByNumber_data: null,
    getDueInvoices_data: null,
    getInvoicesByUpdateRange_data: null,
    createInvoice_data: null,
    getCompanyInfo_data: null,
    downloadExcel_data:null,
    disconnect_data: null,
    getAccounts_data: null,
}

const getters = {}

const mutations = {
    set_authUri(state, data) { state.authUri_data = data },
    set_callback(state, data) { state.callback_data = data },
    set_getRealm(state, data) { state.getRealm_data = data },
    set_getHost(state, data) { state.getHost_data = data },
    set_refreshAccessToken(state, data) { state.refreshAccessToken_data = data },
    set_getInvoiceByNumber(state, data) { state.getInvoiceByNumber_data = data },
    set_getDueInvoices(state, data) { state.getDueInvoices_data = data },
    set_getInvoicesByUpdateRange(state, data) { state.getInvoicesByUpdateRange_data = data },
    set_createInvoice(state, data) { state.createInvoice_data = data },
    set_getCompanyInfo(state, data) { state.getCompanyInfo_data = data },
    set_downloadExcel(state, data) { state.downloadExcel_data = data },
    set_disconnect(state, data) { state.disconnect_data = data },
    set_getAccounts(state, data) { state.getAccounts_data = data },
}

const actions = {
    async queryQuickbook({ dispatch, commit, state, rootState, rootGetters }, { ams_request, cmd, silent = false }) {
        try {
            state.loadingId = cmd
            const FunctionName = `arn:aws:lambda:us-east-1:481228531267:function:QuickBookLambdaStack-QuickBookLambdaFunction-5IIHwW1E9YaC${rootGetters.is_development ? '' : ':PROD'}`
            await dispatch('js_report/fetchCredentials', {}, { root: true })

            const {
                key: accessKeyId,
                secret: secretAccessKey,
                token: sessionToken,
                region,
            } = rootState.js_report.aws_credentials

            const options = {
                region,
                accessKeyId,
                secretAccessKey,
                sessionToken,
            }

            AWS.config.update(options)
            const lambda = new AWS.Lambda()

            // Check if rootGetters.baseURL exists
            if (!rootGetters.baseURL) {
                if (cmd === commands.getHost) {
                    // Handle this gracefully for getHost
                    commit(`set_${cmd}`, { realmId: null, token: null, setup_status: "pending" });
                    return;
                }
                throw new Error('Base URL is not defined');
            }

            const { hostname: host } = new URL(rootGetters.baseURL)
            console.log("quickbook cmd:", cmd)
            console.log("quickbook host:", host)

            ams_request = ams_request || {};
            ams_request.host = host
            const Payload = JSON.stringify({
                ams_request, cmd
            })

            const params = {
                FunctionName,
                Payload,
                LogType: 'Tail' // Request the execution logs
            }

            console.log("Invoking Lambda with params:", {
                FunctionName,
                cmd,
                host
            })

            try {
                const { Payload: resp, LogResult } = await lambda.invoke(params).promise()
                
                // Log any execution logs we received (for debugging)
                if (LogResult) {
                    const decodedLogs = Buffer.from(LogResult, 'base64').toString('utf-8')
                    console.log("Lambda execution logs:", decodedLogs)
                }

                const parsedResp = JSON.parse(resp);
                console.log("Lambda response:", parsedResp)
                
                const { statusCode, body } = parsedResp;

                if (statusCode != 200) {
                    // Handle error with better messaging
                    const errorMessage = (typeof body === 'string') ? body : JSON.stringify(body);
                    
                    // Special case: if this is getHost cmd and we're just starting out, we'll get an error
                    // about no realmId, but we can ignore it since our Lambda function now handles this case
                    if (cmd === commands.getHost && errorMessage.includes("Failed to retrieve realmId")) {
                        // We just don't have a connection yet - this is an expected condition
                        commit(`set_${cmd}`, { realmId: null, token: null, setup_status: "pending" });
                        return;
                    }
                    
                    throw new Error(errorMessage);
                }

                const setData = `set_${cmd}`;
                console.log(setData);
                if (typeof body == 'string') {
                    console.log("text received")
                } else if (typeof body == 'object') {
                    console.log("object received")
                }
                commit(setData, body);
            } catch (lambdaErr) {
                console.error("Lambda invocation error:", lambdaErr)
                // If this is an AWS service error (vs. a parsing error)
                if (lambdaErr.code && lambdaErr.message) {
                    throw new Error(`AWS Lambda error: [${lambdaErr.code}] ${lambdaErr.message}`)
                }
                // Otherwise, re-throw
                throw lambdaErr
            }
        } catch (err) {
            // Always log to console for debugging
            console.error("QuickBooks API error:", err)
            
            // Only call the error handler if we're not in silent mode
            if (!silent) {
                errorHandler(err)
            }
            
            // For certain commands, we want to provide a more helpful error state
            if (cmd === commands.getHost) {
                commit(`set_${cmd}`, { error: err.message, setup_status: "error" });
            }
        } finally {
            state.loadingId = null
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}